import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { DatePipe } from '@angular/common';
import swal from 'sweetalert2';
import { analyzeAndValidateNgModules } from '@angular/compiler';

@Component({
  selector: 'app-sb-intrest-calculation',
  templateUrl: './sb-intrest-calculation.component.html',
  styleUrls: ['./sb-intrest-calculation.component.css']
})
export class SbIntrestCalculationComponent implements OnInit {
  title = "SB Interest Calculation";
  sbint:any={}
  branchdt: any;
  brnchopt:any=[];
  b :any={};
  sbschdata: any;
  sbschopt: any;
  sbs:any={};
  logbranch:number;
  today = new Date();  
  DateValues:string;
  sbintolddata:any;
  sbintoldopt:any=[];
  sbintoldo:any={};
  inttotal:any;

  constructor(private service:UserService,private datePipe:DatePipe)
   { }

  ngOnInit()
  {
    this.getbranchd();
    //this.getschme(this.logbranch);
    this.sbint.trnsdt=this.getdatefun(this.today);
  }

  getbranchd()
  {
   //let BRANCH_ID=localStorage.getItem('BRANCH_ID');
   this.branchdt=this.service.getbranch();
   this.branchdt.subscribe(
    (bresponse:any)=>{
      // //this.sbint.branchsel=BRANCH_ID;
       this.brnchopt=bresponse.BranchModels;
      // for(let i=0;i<bresponse.BranchModels.length;i++){
      //   if(BRANCH_ID==bresponse.BranchModels[i].BRANCH_ID){
      //     this.brnchopt.push(bresponse.BranchModels[i]);
        console.log(this.brnchopt);
      //   }
      // }
      //this.logbranch=parseInt(BRANCH_ID);
    //  this.acsetbranch(BRANCH_ID);
      // console.log(BRANCH_ID);
      // console.log(this.brnchopt);
    })
  }

  getschme(branch:number)
  {
    debugger;
    this.sbschdata=this.service.loadscheme(branch);
    this.sbschdata.subscribe(
      (scresponse:any)=>{
        console.log(scresponse);
        this.sbschopt=scresponse;
        console.log(this.sbschopt);
      }
    )
  }
  getdatefun(indt:any)
  {
    debugger;
    this.DateValues=this.datePipe.transform(indt,'yyyy-MM-dd');
    return this.DateValues;
  }


  getdatasblist(frmdt:any,todt:any,minbal:number,minint:number,branchsel:number,schem:number,trnsdt:any,accfrm:number,accto:number,intrat:number,stafrat:number,accno:string,accname:string,typeofdura:string)
  {
    //swal('SHALL I SHOW ALREADY GENEREATED', 'INFO', 'success');
    swal({
      title:'PEACE',
      text: "SHALL I SHOW ALREADY GENEREATED LIST OF ACCOUNTS?",
    type: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes',
    cancelButtonText:'No'
    }).then((result) => {
    if (result.value) {
      // swal(
      //  'Cleared!',
      //  'Your file has been Cleared.',
      //  'success'
      // )
      debugger;
      this.sbintold(accfrm,accto);
       // console.log("you have clicked yes");

  }
  else{
    this.sbintnew(frmdt,todt,minbal,minint,branchsel,schem,trnsdt,accfrm,accto,intrat,stafrat,accno,accname,typeofdura);
    //console.log("you have clicked no");
  }

  });
//********* */
  }

  sbintold(frmac:number,toac:number)
  {

    this.sbintolddata=this.service.sbintolddata(frmac,toac);
    this.sbintolddata.subscribe(
      (sbinres:any)=>{
        this.sbintoldopt=sbinres;
        this.sbint.inttotal=this. calculatetotalint();
      }
    )
  }
  calculatetotalint()
  {    var intamt=0;
    for(let i=0;i<this.sbintoldopt.length;i++)
    {
      intamt=+(intamt)+(this.sbintoldopt[i].INT_AMT);
    }
    return intamt.toFixed(2);
  }

  sbintnew(frmdt:any,todt:any,minbal:number,minint:number,branchsel:number,schem:number,trnsdt:any,accfrm:number,accto:number,intrat:number,stafrat:number,accno:string,accname:string,typeofdura:string)
  {
    this.sbintoldopt=this.service.sbintnewdata(frmdt,todt,minbal,minint,branchsel,schem,trnsdt,accfrm,accto,intrat,stafrat,this.checkstringnul(accno),this.checkstringnul(accname),typeofdura);
   this.sbintoldopt.subscribe(
     (sbintnewres:any)=>
     {
       this.sbintoldopt=sbintnewres;
       this.sbint.inttotal=this. calculatetotalint();
     }
   )
  }
  
  checkstringnul(str:string)
  {
    if(str!=null)
    {
      return str;
    }
    else
     return "";
  }
  checknull(chknum:number)
  {
    debugger;
    if(chknum==null)
       return 0;
     else
       return chknum;
  }

}



// WEBPACK FOOTER //
// ./src/app/othertransaction/sb-intrest-calculation/sb-intrest-calculation.component.ts